(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("underscore")) : factory(root["underscore"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 157);
/******/ })
/************************************************************************/
/******/ ({

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(158);


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Registry", {
  enumerable: true,
  get: function get() {
    return _index.Registry;
  }
});

var _index = __webpack_require__(159);

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Registry = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-mixed-operators */

/* eslint no-param-reassign: 0 */

/** Class representing a namespace */
var Namespace =
/** @class */
function () {
  /**
   * Create a namespace
   * @param {Namespace|null} parent - The parent namespace
   */
  function Namespace(parent) {
    this.map = {};
    this.parent = parent;
  }
  /**
   * Resolve an object by name
   * @param {String[]} segments - The name segments
   * @return {Object} The object registered with the given name
   */


  Namespace.prototype.resolve = function (segments) {
    var iterator = function iterator(ns, seg) {
      if (ns && ns instanceof Namespace) {
        return ns.map[seg];
      }

      return ns;
    };

    return _underscore.default.reduce(segments, iterator, this) || this.parent && this.parent.resolve(segments);
  };
  /**
   * Register an object
   * @param {Object} obj - The object to be registered
   * @param {String[]} segments - The name segments for the object
   * @return {Void} Nothing to return
   */


  Namespace.prototype.register = function (obj, segments) {
    var key = segments.pop();

    var iterator = function iterator(ns, seg) {
      if (ns instanceof Namespace) {
        if (_underscore.default.isUndefined(ns.map[seg])) {
          ns.map[seg] = new Namespace(ns);
        }

        return ns.map[seg];
      }

      throw new Error("There are conflicts when defining registry for " + segments.join('.'));
    };

    var nsTarget = _underscore.default.reduce(segments, iterator, this);

    nsTarget.map[key] = obj;
  };
  /**
   * Iterate through all objects in this namespace
   * @param {Function} worker - The callback for each of the objects
   * @return {void} Nothing to return
   */


  Namespace.prototype.each = function (worker) {
    _underscore.default.each(this.map, function (obj) {
      if (obj instanceof Namespace) {
        obj.each(worker);
      } else {
        worker(obj);
      }
    });
  };

  return Namespace;
}();

function isObjectWithName(obj) {
  return typeof obj.name === 'string';
}
/** Class representing a namespaced registry */


var Registry =
/** @class */
function () {
  /**
   * Create a registry
   */
  function Registry() {
    this.rootNamespace = new Namespace(null);
    this.qualifiedNames = new Map();
  }
  /**
   * Resolve an object by name
   * @param {String} name - The name of the object
   * @param {String} [namespace=this.rootNamespace] - The base namespace to resolve against
   * @return {Object|null} The object registered with the name
   */


  Registry.prototype.resolve = function (name, namespace) {
    var ns = namespace ? this.rootNamespace.resolve(namespace.split('.')) : this.rootNamespace;
    var obj = ns instanceof Namespace ? ns.resolve(name.split('.')) : null;
    return obj || null;
  };

  Registry.prototype.resolveQualifiedName = function (name, namespace) {
    var obj = this.resolve(name, namespace);

    if (obj instanceof Namespace || !obj) {
      return null;
    }

    return this.qualifiedNames.get(obj) || null;
  };
  /**
   * Register an object
   * @param {Object} obj - The object to be registered
   * @param {String} [name=obj.name] - The qualified name for the object
   * @return {void} Nothing to return
   */


  Registry.prototype.register = function (obj, name) {
    var realName = !name && isObjectWithName(obj) ? obj.name : name;

    if (typeof realName === 'undefined') {
      throw new Error("name not passed in and obj " + JSON.stringify(obj) + " doesn't have name property");
    }

    this.rootNamespace.register(obj, realName.split('.'));
    this.qualifiedNames.set(obj, realName);
  };
  /**
   * Iterate through all registered objects
   * @param {Function} worker - The callback for each of the objects
   * @return {void} Nothing to return
   */


  Registry.prototype.each = function (worker) {
    this.rootNamespace.each(worker);
  };
  /**
   * Get namespace from a qualified name
   * @param {String} name - The qualified name
   * @return {String} The namespace
   */


  Registry.getNamespace = function (name) {
    var segments = name.split('.');
    segments.pop();
    return segments.join('.');
  };
  /**
   * Get short name from a qualified name
   * @param {String} name - The qualified name
   * @return {String} The short name
   */


  Registry.getShortName = function (name) {
    return _underscore.default.last(name.split('.'));
  };

  Registry.getQualifiedName = function (name, namespace) {
    return namespace ? namespace + "." + name : name;
  };

  return Registry;
}();

exports.Registry = Registry;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ })

/******/ });
});
